import GroupIcon from '@mui/icons-material/Group';
import { useState } from 'react';
import { ContractsListDialog } from './contracts-list.dialog';
import { GridCountCell } from '../../components/grid-cell-count';
import { useLocation } from 'react-router-dom';
import { useAuthorize } from '../../hooks/use-authorize';
import { UserPermissionName } from '../../models/user-permission-name';

interface CellProps {
  count: number;
  officeID: number;
}

const styling = {
  iconStyle: { color: '$primary-color' },
  textStyle: { paddingLeft: '5px', color: '$primary-color' },
};

export const ContractsCount = ({ count, officeID }: CellProps) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const location = useLocation();
  const handleCloseDialog = () => {
    setIsDialogVisible(false);
  };

  const handleCountClick = () => {
    setIsDialogVisible(true);
  };

  const handleCheckPermission = () => {
    const pathParts = location.pathname?.split('/');
    const parentPage = pathParts[1];

    if (parentPage === 'customers') {
      const isContractPermission = useAuthorize([UserPermissionName.VIEW_CONTRACT_CUSTOMER]);

      return isContractPermission;
    } else if (parentPage === 'offices') {
      const isContractPermission = useAuthorize([UserPermissionName.VIEW_CONTRACT_OFFICE]);
      return isContractPermission;
    } else {
      return true;
    }
  };

  return (
    <>
      <GridCountCell
        isDisabled={!handleCheckPermission()}
        count={count}
        icon={<GroupIcon style={styling.iconStyle} />}
        onClick={handleCountClick}
      />
      {isDialogVisible && (
        <ContractsListDialog officeID={officeID} open={isDialogVisible} onClose={handleCloseDialog} />
      )}
    </>
  );
};
